// @ts-ignore
import confetti from '../../../../../assets/animations/confetti.gif';
import { Headline3 } from '../../../../../components/Elements';
import strings from '../../../../../strings/strings.json';
import Notification, { NotificationType } from '../../../../../components/notifiers/Notification';
import * as React from 'react';
import styled from 'styled-components';
import { breakpoints, sizes } from '../../../../../theme';
import { LearnerCardBase } from 'pages/learner/sharedStyles/LearnerStyles';

export default function QuestionnaireComplete(): JSX.Element {
    return (
        <CompleteContainer>
            <Image src={confetti} aria-hidden={true} />
            <TextContent>
                <Headline3>{strings.questionnaireCompletePage.questionnaireCompleteHeaderText}</Headline3>
                <Notification
                    notificationType={NotificationType.SUCCESS}
                    title={strings.questionnaireCompletePage.successNotificationText}
                    maxWidth="1000"
                />
            </TextContent>
        </CompleteContainer>
    );
}

const CompleteContainer = styled(LearnerCardBase)`
    position: relative;
    height: 400px;
    z-index: 0;

    @media (max-width: ${breakpoints.md}) {
        height: 300px;
    }
`;

const Image = styled.img`
    position: absolute;
    z-index: -1;
    width: 95%;
    height: 95%;
    left: 10px;
    top: 10px;
`;

const TextContent = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    margin: ${sizes.spacingLg};
    gap: ${sizes.spacingLg};

    @media (max-width: ${breakpoints.sm}) {
        gap: ${sizes.spacingMd};
        margin: ${sizes.spacingMd};
    }
`;
